export const SET_FAVORITE_NEWS_FETCHING = 'SET_FAVORITE_NEWS_FETCHING';
export const SET_FAVORITE_NEWS = 'SET_FAVORITE_NEWS';
export const SET_FAVORITE_NEWS_ERROR = 'SET_FAVORITE_NEWS_ERROR';
export const CLEAN_FAVORITE_NEWS = 'CLEAN_FAVORITE_NEWS';
export const UPDATE_FAVORITE_NEWS_FEED_AFTER_READ_USERACTION = 'UPDATE_FAVORITE_NEWS_FEED_AFTER_READ_USERACTION';
export const UPDATE_FAVORITE_NEWS_FEED_AFTER_RATE_USERACTION = 'UPDATE_FAVORITE_NEWS_FEED_AFTER_RATE_USERACTION';
export const UPDATE_FAVORITE_NEWS_FEED_AFTER_CHANGE_IMPORTANCE = 'UPDATE_FAVORITE_NEWS_FEED_AFTER_CHANGE_IMPORTANCE';
export const ABORT_FAVORITE_NEWS_REQUEST = 'ABORT_FAVORITE_NEWS_REQUEST';
export const RESET_FAVORITE_NEWS_FETCHING = 'RESET_FAVORITE_NEWS_FETCHING';



// WEBPACK FOOTER //
// ./src/redux_related/favoriteNews/actions.js